import { render, staticRenderFns } from "./GroupDevMaster.vue?vue&type=template&id=53efba5e&scoped=true"
import script from "./GroupDevMaster.vue?vue&type=script&lang=js"
export * from "./GroupDevMaster.vue?vue&type=script&lang=js"
import style0 from "./GroupDevMaster.vue?vue&type=style&index=0&id=53efba5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53efba5e",
  null
  
)

export default component.exports